import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Card } from '@manulife/mux';
import {
  FormattedRichMessage,
  RealmSpecific,
  REALMS,
  HEADER_REALM_KEYS,
  useRealm,
  usePathBuilder,
  useRedesignContext,
} from 'ciam-self-service-shared';
import HideWhenEmbedded from '../../Embedded/HideWhenEmbedded';
import { Wrapper, ListWrapper } from './styledComponents';
import SignInProductLinkWrapper from './SignInProductLinkWrapper';
export function SignInCurrentRealmAdditionalLinks() {
  const realm = useRealm();
  const intl = useIntl();

  const titleValue = intl.messages[`signin.page.products.${realm.toLowerCase()}.travel.title`];
  const urlValue = intl.messages[`signin.page.products.${realm.toLowerCase()}.travel.link`];
  const tooltipContent = intl.messages[`signin.page.products.${realm.toLowerCase()}.travel.tooltip`];

  return (
    <RealmSpecific showFor={[REALMS.CUSTOMER]}>
      <SignInProductLinkWrapper
        to={urlValue}
        messageId={`signin.page.products.${realm.toLowerCase()}.travel.title`}
        tooltipContent={tooltipContent}
        showTooltip={true}
        analyticsData={{
          click: {
            linkName: titleValue,
            linkHref: urlValue,
          },
        }}
      />
    </RealmSpecific>
  );
}

export function SignInProductInfoRealmLink(props) {
  const { realm } = props;
  const pathBuilder = usePathBuilder();
  const otherRealmsUrl = pathBuilder('/', true, { realm });
  const { showRedesignedView } = useRedesignContext();
  const intl = useIntl();

  return (
    <RealmSpecific hideFor={[realm]}>
      <Wrapper>
        {!showRedesignedView && <FormattedRichMessage id={`signin.page.products.${realm.toLowerCase()}.message`} />}
        <SignInProductLinkWrapper
          to={otherRealmsUrl}
          messageId={`signin.page.products.${realm.toLowerCase()}.message.button`}
          analyticsData={{
            click: {
              linkName: intl.messages[`signin.page.products.${realm.toLowerCase()}.message.button`],
              linkHref: otherRealmsUrl,
            },
          }}
          showRedesignedView={showRedesignedView}
        />
      </Wrapper>
    </RealmSpecific>
  );
}

SignInProductInfoRealmLink.propTypes = {
  realm: PropTypes.string.isRequired,
};

export default function SignInProductInfo() {
  const realm = useRealm();

  return (
    <HideWhenEmbedded>
      <RealmSpecific showFor={[REALMS.CUSTOMER, REALMS.ADVISOR, REALMS.SPONSOR]}>
        <Card>
          <Card.Content>
            <Wrapper>
              <FormattedRichMessage id="signin.page.products.title" />
              <ListWrapper id="product-section">
                <FormattedRichMessage id={`signin.page.products.${realm}.list`} />
              </ListWrapper>
            </Wrapper>

            {HEADER_REALM_KEYS.map((realmKey) => (
              <SignInProductInfoRealmLink key={realmKey} realm={REALMS[realmKey]} />
            ))}
          </Card.Content>
        </Card>
      </RealmSpecific>
    </HideWhenEmbedded>
  );
}
